import { IRootState } from '../../../store'
import { IBillingState } from '../store/billing.types'

export const getBillingSelector = (state: IRootState): IBillingState => state.billing
